export const ProviderNames: Record<number, string> = {
  1: "WeAreCasino",
  2: "AWC",
  3: "GAP",
  4: "DC",
  5: "QTech",
  6: "Supernowa",
  7: "SAP",
  8: "BetBy",
  9: "9Wickets",
};